import { createContext, useContext, type ReactNode } from "react";
import type { CustomerRuntime } from "../../application/foundation/customer-runtime";
import type { OrganizationId } from "../../shared/identifiers/ids";
import type { NaveSessionBootstrap } from "../../read-models/identity/nave-session-bootstrap";
export type ScenarioContextValue = Readonly<{
  session?: NaveSessionBootstrap;
  switching?: boolean;
  switchError?: boolean;
  setClient?(id:string):void;
  runtime: CustomerRuntime;
  activeOrganizationId: OrganizationId;
  setOrganization(id: OrganizationId): void;
}>;
const ScenarioContext = createContext<ScenarioContextValue | undefined>(undefined);
export const CustomerRuntimeProvider = ({ value, children }: { value: ScenarioContextValue; children?: ReactNode }) =>
  <ScenarioContext.Provider value={value}>{children}</ScenarioContext.Provider>;
export const useScenario = (): ScenarioContextValue => {
  const value = useContext(ScenarioContext);
  if (value === undefined) throw new Error("Customer runtime missing");
  return value;
};
